<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="auto"
  >
    <template #header>
      索赔模版
    </template>
    <template #content>
      <gj-alert type="warning" show-icon style="margin-bottom: 20px" border>
        请在对应店铺/站点的亚马逊卖家后台进行申诉，<span style="color: red">避免关联</span>；<br/>
        申诉地址：登录卖家后台 -> Help -> Get support -> Selling on amzon -> Or, browse for your issue in the menu -> <br/>Fulfillent by amazon -> Orders -> Request Order Reimbursement Investigate/Request Reimbursement for a Multichannel Order；
      </gj-alert>
      <el-form
          :model="form"
          label-width="160px"
      >
        <el-form-item
            label="店铺/国家"
        >
          {{claimTemplate.marketId | optionText(marketOption)}}
        </el-form-item>
        <el-form-item 
          label="需要准备资料"
        >
          <div >
            <div class="info">亚马逊订单编号：{{claimTemplate.orderId | defaultShow}} <gj-button v-if="claimTemplate.orderId" v-copy="claimTemplate.orderId" type="primary" size="mini" class="button-view">复制</gj-button></div>
            <div class="info">MSKU：{{claimTemplate.msku | defaultShow}} <gj-button v-if="claimTemplate.msku" v-copy="claimTemplate.msku" type="primary"  size="mini" class="button-view">复制</gj-button></div>
            <div class="info">ASIN：{{claimTemplate.asin | defaultShow}} <gj-button v-if="claimTemplate.asin" v-copy="claimTemplate.asin" type="primary"  size="mini" class="button-view">复制</gj-button></div>
            <div class="info">FNSKU：{{claimTemplate.fnsku | defaultShow}} <gj-button v-if="claimTemplate.fnsku" v-copy="claimTemplate.fnsku" type="primary"  size="mini" class="button-view">复制</gj-button></div>
          </div>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "@/minxins";
import {mapGetters} from "vuex";
  export default {
    name: "claim-goods-case-template",
    mixins: [modalMixIn],
    props: {
      item: null,
      claimTemplate:{
        
      }
    },
    computed:{
      ...mapGetters({
        marketOption: "marketOption",
      }),
    },
    data() {
      return {
        form: {
        }
      }
    },
    methods: {
     
    }
  }
</script>

<style scoped>
  .button-view{
    margin-left: 20px;
  }

  .info{
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    color: #333333;
  }

</style>
